import { render, staticRenderFns } from "./paperFeedBack.html?vue&type=template&id=3393925f&"
import script from "./paperFeedBack.ts?vue&type=script&lang=ts&"
export * from "./paperFeedBack.ts?vue&type=script&lang=ts&"
import style0 from "./paperFeedBack.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports